import React from 'react';
import { useGetDoneAchievedTasks } from '../../Controllers/TaskManagementController';

const DoneAchievedCard = ({ date }) => {
    const getParams = () => {
        const params = {};
        let dateToFormat;

        if (date === null) {
            dateToFormat = new Date();
        } else {
            dateToFormat = new Date(date);
        }

        const yyyy = dateToFormat.getFullYear();
        const mm = String(dateToFormat.getMonth() + 1).padStart(2, '0');
        const dd = String(dateToFormat.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;

        params.fromDate = formattedDate;
        params.toDate = formattedDate;

        return params;
    };

    const { data, isLoading, isError } = useGetDoneAchievedTasks(getParams());

    // --- Start: Dynamic Data Processing ---
    // 1. Achieved MIT Tasks
    const achievedMitTasks = React.useMemo(() =>
        (data?.achieved_tasks || []).filter(task => task.level === 'MIT List'),
        [data]);

    // 2. Not Achieved MIT Tasks
    const notAchievedMitTasks = React.useMemo(() =>
        (data?.not_done || []).filter(task => task.level === 'MIT List'),
        [data]);

    // 3. Done Do List Tasks
    const doneDoTasks = React.useMemo(() =>
        (data?.done_tasks || []).filter(task => task.level === 'Do List'),
        [data]);

    // 4. Not Done Do List Tasks
    const notDoneDoTasks = React.useMemo(() =>
        (data?.not_done || []).filter(task => task.level === 'Do List'),
        [data]);

    const hasAnyTasks = achievedMitTasks.length > 0 || notAchievedMitTasks.length > 0 || doneDoTasks.length > 0 || notDoneDoTasks.length > 0;
    // --- End: Dynamic Data Processing ---


    if (isLoading) {
        return (
            <div className="win-stack-card">
                <div className="text-body-b3" style={{ color: '#9db2c1' }}>Loading tasks...</div>
            </div>
        );
    }

    if (isError) {
        return (
            <div className="win-stack-card">
                <div className="text-body-b3" style={{ color: '#ff4757' }}>Error loading tasks.</div>
            </div>
        );
    }

    if (!hasAnyTasks) return null;



    return (
        <div className="win-stack-card">
            <style>{`
                .win-stack-card { border-radius: 16px; margin-top: 12px; padding: 12px; background: #0f2a36; margin-bottom: 24px; }
                .ws-section-title { color: #9db2c1; font-weight: 600; margin: 12px 0 8px; display: flex; align-items: center; gap: 8px; }
                .ws-item { display: flex; align-items: flex-start; gap: 8px; color: #e6ecf1; margin-bottom: 8px; }
                .ws-icon { width: 10px; height: 10px; flex: 0 0 10px; margin-top: 6px; margin-right:5px; }
                .ws-separator { height: 8px; }
                .ws-task-level { color: #9db2c1; font-weight: 600; margin-right: 4px; }
            `}</style>

            {/* 1. Achieved tasks (MIT List) */}
            {achievedMitTasks.length > 0 && (
                <div>
                    <div className="ws-section-title">
                        <span>Achieved (MIT List)</span>
                    </div>
                    {achievedMitTasks.map((task) => (
                        <div key={task.id} className="ws-item">
                            <img src={"/icons/smalltick.svg"} className="ws-icon" alt="status" />
                            <div>
                                <span className="text-body-b3" dangerouslySetInnerHTML={{ __html: task.title }} />
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* 2. MIT Not Done */}
            {notAchievedMitTasks.length > 0 && (
                <div>
                    <div className="ws-section-title">
                        <span>Not Achieved (MIT List)</span>
                    </div>
                    {notAchievedMitTasks.map((task) => (
                        <div key={task.id} className="ws-item">
                            <img src={"/icons/smallcross.svg"} className="ws-icon" alt="status" />
                            <div>
                                <span className="text-body-b3" dangerouslySetInnerHTML={{ __html: task.title }} />
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* 3. Done Tasks (Do List) */}
            {doneDoTasks.length > 0 && (
                <div>
                    <div className="ws-section-title">
                        <span>Done (Do List)</span>
                    </div>
                    {doneDoTasks.map((task) => (
                        <div key={task.id} className="ws-item">
                            <img src={"/icons/smalltick.svg"} className="ws-icon" alt="status" />
                            <div>
                                <span className="text-body-b3" dangerouslySetInnerHTML={{ __html: task.title }} />
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* 4. Do List Not Done Tasks */}
            {notDoneDoTasks.length > 0 && (
                <div>
                    <div className="ws-section-title">
                        <span>Not Done (Do List)</span>
                    </div>
                    {notDoneDoTasks.map((task) => (
                        <div key={task.id} className="ws-item">
                            <img src={"/icons/smallcross.svg"} className="ws-icon" alt="status" />
                            <div>
                                <span className="text-body-b3" dangerouslySetInnerHTML={{ __html: task.title }} />
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default DoneAchievedCard;

